/**
 * Restaurant
 *
 * View that handles the restaurant popup card
 *
 * @return {view}
 */

OT.createNS('OT.Redesign.Views.Modals.Restaurant');

OT.Redesign.Views.Modals.Restaurant = Backbone.ViewManager.BaseView.extend({
    el: '#results_modal',

    template: 'Redesign/Modals/_RestaurantModal',

    beforeRender: function() {
        this.additionalData = {
            request: OT.Search.Data.get().Request,
            showTimeSlots: false
        };

        return true;
    },

    onRender: function() {
        this.$el.show();
        this.position();

        return this;
    },

    position: function() {
        var modal = this.$target.find('.rest-row-offer-link');
        var top = modal.offset().top + modal.height() + 8;
        var $container = this.$target.find('.rest-row-name');
        var left = $container.offset().left;

        this.$el.css({
            'margin-top': top,
            'margin-left': left
        });
    }
});
